import React, { useRef, useState, useEffect } from 'react';
import AvatarEditor from 'react-avatar-editor';
import styled from 'styled-components';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCheck, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { generateNewNameImage } from '../../helpers/utils'
import checkIcon from '../../assets/images/icons/checkWhite.png'
import cancelIcon from '../../assets/images/icons/cancelWhite.png'

export default function ImageCrop(props) {
  const { imageSrc, onCropDone, onCropCancel } = props;
  const [scaleState, setScaleState] = useState('1');
  const onHandleScale = event => {
    setScaleState(event.target.value);
  };
  const setEditorRef = useRef(null);

  useEffect(() => {
    if (imageSrc.name) {
      setScaleState('1');
    }
  }, [imageSrc.name]);

  const handelCropDone = () => {
    onCropDone(
      (setEditorRef).current.getImageScaledToCanvas().toDataURL(),
      generateNewNameImage(),
    );
  };

  return (
    <Container>
      <AvatarEditor
        image={imageSrc}
        border={10}
        borderRadius={220}
        scale={parseFloat(scaleState)}
        rotate={0}
        width={props.size || 250}
        height={props.size || 250}
        ref={setEditorRef}
      ></AvatarEditor>
      <InputRange
        type="range"
        value={scaleState}
        name="points"
        step="0.05"
        min="1"
        max="5"
        onChange={onHandleScale}
      />
      <ButtonContainer>
        <IconButton onClick={handelCropDone}>
          <Icon src={checkIcon} />
        </IconButton>
        <IconButton onClick={onCropCancel}>
          <Icon src={cancelIcon} />
        </IconButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 1px 24px;
`;
const IconButton = styled.button`
  border: none;
  outline: none;
  border-radius: 6px;
  background-color: #abc;
`;
const Icon = styled.img`
  width: 24px;
  height: 24px;
`;
const InputRange = styled.input`
  width: 100%
`;